import React, { createContext, useContext } from 'react';

type State = {
  login: () => void;
  logout: ({ redirectUri }: { redirectUri?: string }) => void;
  usingKeycloak: boolean;
  setKeycloakEnabled: () => void;
  token: null | string;
};

export const KeycloakActionsContext = createContext<State>({
  login: () => {},
  logout: () => {},
  usingKeycloak: false,
  setKeycloakEnabled: () => {},
  token: null,
});

interface Props {
  children: React.ReactNode;
  value?: any;
}

export const KeycloakActionsProvider = ({ children, value }: Props) => (
  <KeycloakActionsContext.Provider value={value}>
    {children}
  </KeycloakActionsContext.Provider>
);

export const useKeycloakActions = () => useContext(KeycloakActionsContext);
